import React, { Component } from 'react';
import $ from 'jquery';
import Loader from 'react-loader-spinner';
import { ToastContainer, toast } from "react-toastify";
import { Progress } from 'react-sweet-progress';

class NlpDeploy extends Component {
    constructor() {
        super();
        this.state = {
            percentage: 0,
            status: null,
            contentEditable: "false",
            successResp: false,
            progressBar: false,
            totalEntitiesTobeParsed: 0,
            numEntitiesParsed: 0,
            lastBuildBy: "",
            lastBuildDate: "",
            recordsPresent: false,
            isCleanBuild: false,
            isBuildInProgress: false
        },
            this.buildSuccess = false
    }

    notifyError() {
        toast(<b style={{ color: "red" }}>Oops! Error occurred. Please try again</b>, {
            position: "top-center",
            color: "red"

        });
    }

    notifyBuildStatusFetchError() {
        toast(<b style={{ color: "red" }}>Snap! Some error occured when trying to get the status...</b>, {
            position: "top-center",
            color: "red"

        });
    }
    initiateDeploy = () => {
        let thisController = this;
        thisController.state.isBuildInProgress = true;
        thisController.setState(thisController.state);
        let data = {
            projectId: localStorage.getItem("currentProjectId"),
        }
        $.ajax({
            url: "/api/deploy-nlp-api",
            type: 'GET',
            headers: {
                "Authorization": "Bearer " + localStorage.getItem("access_token")
            },
            data: data,
            success: function (res) {
                if (res.success === true) {
                    res = res.result;
                    thisController.state.percentage = res.percentage;
                    thisController.state.deployId = res.deployId;
                    thisController.state.startTime = res.startTime;
                    thisController.state.totalEntitiesTobeParsed = res.totalEntitiesTobeParsed;
                    thisController.state.numEntitiesParsed = res.numEntitiesParsed;
                    thisController.state.status = res.status;
                    thisController.setState(thisController.state);
                    if (res.status != 'COMPLETE') {
                        window.buildStatusTimeoutHandle = setInterval(function () {
                            thisController.fetchBuildStatusApi();
                        }, 1000);
                    }

                } else {
                    thisController.state.isBuildInProgress = false;
                    thisController.setState({
                        progressBar: false
                    });
                    thisController.notifyError();
                }
            }
        });
    }

    onInitiateBuild = (data) => {
        var thisController = this;
        thisController.initiateDeploy();
        thisController.setState({
            progressBar: true
        });
    }
    fetchBuildStatusApi = () => {
        let thisController = this;
        thisController.state.isBuildInProgress = true;
        thisController.setState(thisController.state);
        $.ajax({
            url: "/api/api-deploy-status",
            type: 'GET',
            async: false,
            headers: {
                "Authorization": "Bearer " + localStorage.getItem("access_token")
            },
            data: {
                deployId: thisController.state.deployId
            },
            success: function (res) {
                if (res.success === true) {
                    res = res.result;
                    thisController.state.percentage = res.percentage;
                    thisController.state.numEntitiesParsed = res.numEntitiesParsed;
                    thisController.state.status = res.status;
                    if (thisController.state.totalEntitiesTobeParsed == 0) {
                        thisController.state.totalEntitiesTobeParsed = res.totalEntitiesTobeParsed;
                        thisController.setState(thisController.state);
                    }
                    if (res.status == 'COMPLETE') {
                        clearTimeout(window.buildStatusTimeoutHandle);
                        thisController.buildSuccess = true;
                        thisController.state.isBuildInProgress = false;

                    } else if (res.status == 'ERROR') {
                        clearTimeout(window.buildStatusTimeoutHandle);
                        thisController.state.isBuildInProgress = false;
                        thisController.setState({
                            progressBar: false
                        });
                        thisController.notifyBuildStatusFetchError();
                    }
                    thisController.setState(thisController.state);
                } else {
                    thisController.state.isBuildInProgress = false;
                    thisController.setState({
                        progressBar: false
                    });
                    thisController.notifyBuildStatusFetchError();
                }
            },
            error: function (xhr) {
                if (xhr.status == 401) {
                    window.location.href = "/";
                }
            }
        });
    }

    componentDidMount() {
        var buildController = this;
        // this.getBuildInfo();
        document.addEventListener("projectChanged", function (event) {
            // buildController.getBuildInfo();
        });
    }
    componentWillUnmount() {
        clearTimeout(window.buildStatusTimeoutHandle);
    }
    render() {
        return (
            <div>
                {/* for toaster */}
                <link rel="stylesheet" href="./assets/css/ReactToastify.css" />
                <link rel="stylesheet" href="assets/css/toggleButton.css" />
                <div style={{ marginRight: '1%' }}>
                    {/*---------------SUB-TITLE--------------------------------------------------------------------  */}
                    <div className="wrapper" style={{ height: "450px" }}>
                        {/*--------------BUILD-BUTTON--------------------------------------------------------------------------  */}

                        <div className="row" style={{ marginTop: '10px', marginLeft: '1px' }}>
                            <div className="col-sm-3 p-0">
                                <button className="btn action-button"
                                    id="addMsg"
                                    onClick={this.onInitiateBuild}
                                    disabled={this.state.isBuildInProgress}
                                    style={{ borderRadius: '4px', width: '30%', height: '30px' }}>Deploy</button>
                            </div>

                            <div className="col-sm-4 p-0">
                            </div>
                            <div className="col-sm-5 p-0"></div>
                            <h1></h1>
                        </div>
                        {/* --------------------------------PROGRESS-BAR-------------------------------------------------- */}
                        <div className="content-header">
                            <div className="row" style={{ marginTop: '5px', marginLeft: '1px' }}>
                                <div className="col-sm-4 p-0">
                                    <Progress
                                        style={{ display: this.state.progressBar ? 'block' : 'none' }}
                                        id="build"
                                        width="500px"
                                        height="50px"
                                        rectBorderRadius="1px"
                                        percent={this.state.percentage}
                                    />
                                </div>
                            </div>
                        </div>
                        {/* --------------------------------TEXT-AREA-------------------------------------------------- */}

                        <div className="content-header">
                            <div className="container-fluid">
                                <div className="row" style={{ marginTop: '1px', marginLeft: '1px' }}>
                                    <div className="col-sm-4 p-0">
                                        <div name="description">
                                            <textarea
                                                style={{
                                                    display: this.state.progressBar ? 'block' : 'none',
                                                    background: 'white', resize: 'none', height: "67px",
                                                    fontSize: "0.891em"
                                                }}
                                                className="form-control"
                                                value={this.state.status != null ? "Total number of entities to be processed : " +
                                                    this.state.totalEntitiesTobeParsed + '\n' + "Number of entities processed : "
                                                    + this.state.numEntitiesParsed + '\n' + "Overall Status : " : ""}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div >

        )
    }
}
export default NlpDeploy


// WEBPACK FOOTER //
// ./src/nlpUi/NlpDeploy.js